.cms-loading {
  gap: 0.4em;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
  color: var(--color-dark-grey);
  font-family: var(--font-main);
  font-size: var( --font-size-l);

  @include loader-wrapper;
}
